"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsperaVersionBanner = void 0;
/* eslint-disable @typescript-eslint/no-unused-vars */
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
require("./AsperaBanner.scss");
var matomo_1 = require("@app/shared/matomo");
var AsperaVersionBanner = function (props) {
    var onDownloadClick = function (event) {
        new matomo_1.MatomoTracker().trackEvent('User', 'Clicked Aspera Extension Install Link');
        props.onDisplayModal();
    };
    return (react_1.default.createElement("div", { className: classnames_1.default('aspera-version-banner', { show: props.isVisible }) },
        react_1.default.createElement("nav", { className: "level is-mobile" },
            react_1.default.createElement("div", { className: "level-left" },
                react_1.default.createElement("div", { className: "level-item" },
                    react_1.default.createElement("span", { className: "icon" },
                        react_1.default.createElement("i", { className: "fas fa-exclamation-triangle" }))),
                react_1.default.createElement("div", { className: "level-item" },
                    react_1.default.createElement("div", { className: "warning-text" },
                        react_1.default.createElement("p", null,
                            react_1.default.createElement("span", { className: "has-text-weight-bold" }, "Warning!"),
                            " Your version of Aspera Connect is ",
                            react_1.default.createElement("span", { className: "important" }, "out of date")),
                        react_1.default.createElement("p", null,
                            "For best results with file transfers, please click ",
                            react_1.default.createElement("a", { onClick: onDownloadClick, target: "_blank" }, "HERE"),
                            " to upgrade the Aspera plugin")))),
            react_1.default.createElement("div", { className: "level-right" },
                react_1.default.createElement("div", { className: "level-item" },
                    react_1.default.createElement("a", { className: "has-text-dark", title: "Dismiss", onClick: props.onDismiss },
                        react_1.default.createElement("span", { className: "icon" },
                            react_1.default.createElement("i", { className: "fas fa-times" }))))))));
};
exports.AsperaVersionBanner = AsperaVersionBanner;
